import React, { lazy, Suspense } from 'react';
// import { callOptimizeEvent } from '../../utility/analytics';
// import config from '../../utility/config';

//Do not remove the commented code, might need later
const HomePageNewVersion = lazy(() => import('../HomePage'));
// const HomePageOldVersion = lazy(() => import('../OldHomePage'));

// const newHomePageId = '0';
// const newHomePageCreatorId = '1';
// const oldHomePageId = '2';

const HomePageABContainer = (props) => {
  // const [ABVariant, setABVariant] = useState(newHomePageId);

  // const renderHomePage = () => {
  //   if (newHomePageCreatorId === ABVariant) {
  //     return <HomePageNewVersion isCreatorVariant={true} />;
  //   } else if (oldHomePageId === ABVariant) {
  //     return <HomePageOldVersion />;
  //   } else {
  //     return <HomePageNewVersion />;
  //   }
  // };

  // useEffect(() => {
  //   const GOExpId = config?.homePageGOExperimentId;
  //   if (GOExpId) callOptimizeEvent(GOExpId, setABVariant);

  //   const timer = setTimeout(() => {
  //     if (!ABVariant) setABVariant(newHomePageId);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <Suspense
      fallback={<div style={{ background: '#2c2d2e', height: '100%' }} />}
    >
      <HomePageNewVersion isCreatorVariant={true} {...props} />
    </Suspense>
  );
};

export default HomePageABContainer;
